import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import secureLocalStorage from "react-secure-storage";
import { json, useNavigate, useParams } from "react-router-dom";
import { POST_CUSTOM_MEAL_ENDPOINT } from "../../config/ApisCollection";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { currentMonthYearDay } from "../../function/functions";

const CreateCustomMeal = () => {
  // State to hold form data
  const { type, category } = useParams();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const dietTypesArray = [
    {
      option: "Fully plant",
      optionValue: "isFullyPlantBased",
    },
    {
      option: "Vegetarian",
      optionValue: "isVegetarian",
    },
    {
      option: "Pescatarian",
      optionValue: "isPescatarian",
    },
    {
      option: "Lactose Free",
      optionValue: "isLactoseFree",
    },
    {
      option: "Gluten Free",
      optionValue: "isGlutenFree",
    },
    {
      option: "Keto",
      optionValue: "isKeto",
    },
    {
      option: "Vegan",
      optionValue: "isVegan",
    },
    {
      option: "Paleo",
      optionValue: "isPaleo",
    },
    {
      option: "Flexitarian",
      optionValue: "isFlexitarian",
    },
    {
      option: "Low Carb",
      optionValue: "isLowCarb",
    },
    {
      option: "High Protein",
      optionValue: "isHighProtein",
    },
    {
      option: "Mediterranean",
      optionValue: "isMediterranean",
    },
    {
      option: "Atkins",
      optionValue: "isAtkins",
    },
    {
      option: "Dairy Free",
      optionValue: "isDairyFree",
    },
  ];

  const [saveBtnStatus, setSaveBtnStatus] = useState(true);
  const [msgStatus, setMsgStatus] = useState({
    message: null,
    message_type: null,
  });
  const [formData, setFormData] = useState({
    custmealimg: "",
    dietTitle: "",
    dietFrequency: category,
    dietDescription: "",
    dietCal: "",
    dietTypes: "veg",
    isFullyPlantBased: false,
    isVegetarian: false,
    isPescatarian: false,
    isLactoseFree: false,
    isGlutenFree: false,
    isKeto: false,
    isVegan: false,
    isPaleo: false,
    isFlexitarian: false,
    isLowCarb: false,
    isHighProtein: false,
    isMediterranean: false,
    isAtkins: false,
    isDairyFree: false,
    dietIngredients: [
      {
        title: "",
        name: "",
        quantity: "",
        ingredientsCal: "",
        nutrientsFat: "",
        nutrientsCarbs: "",
        nutrientsProtein: "",
        unit: "g",
        ingredientType: "s",
      },
    ],
  });

  let history = useNavigate();

  // Handle change for static fields
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: files[0], // Assuming only one file is selected
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // Handle change for dynamic fields (e.g., ingredients)
  const handleIngredientChange = (index, e) => {
    const { name, value } = e.target;
    const newIngredients = [...formData.dietIngredients];
    newIngredients[index] = {
      ...newIngredients[index],
      [name]: value,
    };

    if (name == "title") {
      newIngredients[index] = {
        ...newIngredients[index],
        ["name"]: value,
      };
    }

    setFormData((prevState) => ({
      ...prevState,
      dietIngredients: newIngredients,
    }));
  };

  // Handle form submission
  const mealFormHandle = (e) => {
    e.preventDefault();
    postCustomMeal(formData);
  };

  // Add a new ingredient field
  const addIngredient = () => {
    setFormData((prevState) => ({
      ...prevState,
      dietIngredients: [
        ...prevState.dietIngredients,
        {
          title: "",
          name: "",
          quantity: "",
          ingredientsCal: "",
          nutrientsFat: "",
          nutrientsCarbs: "",
          nutrientsProtein: "",
          unit: "g",
          ingredientType: "s",
        },
      ],
    }));
  };

  const removeIngredient = () => {
    setFormData((prevState) => ({
      ...prevState,
      dietIngredients: prevState.dietIngredients.slice(0, -1), // Remove the last item
    }));
  };

  const currentMonthYearDay_Data = currentMonthYearDay();
  // Post data to api
  const postCustomMeal = async (formData) => {
    setSaveBtnStatus(false);
    const date = currentMonthYearDay_Data?.formattedTodayDate;
    const day = currentMonthYearDay_Data?.currentDay;
    const dateDayString = `${date} ${day}`;

    // Encode to Base64
    const encoded = btoa(dateDayString);

    const data = new FormData();

    // Append all the regular form fields
    Object.keys(formData).forEach((key) => {
      if (key === "dietIngredients") {
        formData[key].forEach((ingredient, index) => {
          Object.keys(ingredient).forEach((iKey) => {
            data.append(`dietIngredients[${index}][${iKey}]`, ingredient[iKey]);
          });
        });
      } else if (key === "custmealimg" && formData[key]) {
        data.append("custmealimg", formData[key]);
      } else {
        data.append(key, formData[key]);
      }
    });

    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Date-Day": encoded,
        "Content-Type": "multipart/form-data", // Content type for FormData
      },
    };

    try {
      const response = await axios.post(
        `${POST_CUSTOM_MEAL_ENDPOINT}/done`,
        data,
        post_header
      );
      if (response && response.status === 200) {
        // Optionally handle successful submission
        toast.success("Your custom meal added successfully...");
        setTimeout(() => {
          history("/mealdiet/custom/list/" + category);
        }, 3000);
      }
    } catch (error) {
      setSaveBtnStatus(true);
      toast.error("Meal creation failed");
      console.error("Error posting custom meal:", error);
    }
  };

  useEffect(() => {
    // getExploreData();
    // console.log(formData);
  }, [formData]);

  // console.log(meal_data);

  return (
    <>
      <MainBg>
        <ToastContainer />
        <div className="grid xl:grid-cols-3 grid-cols-1 sm:gap-20 lg:py-20 py-1 mb-20">
          <div className="col-span-2 px-10 sm:border-r-2 border-none">
            <p className="text-2xl font-medium text-center mb-10">
              Describe your <span className="text-[#FF9950]"> Meal</span>{" "}
            </p>

            <form onSubmit={mealFormHandle} encType="multipart/form-data">
              <div className="flex justify-between mt-10">
                <div className="mb-4">
                  <label className="font-bold">Image</label>
                  <input
                    type="file"
                    id="myfile"
                    name="custmealimg"
                    onChange={handleChange}
                    accept=".jpg,.png,.jpeg"
                    className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                    required
                  />
                </div>
              </div>
              <div className="flex justify-between mt-10">
                <div className="mb-4">
                  <label className="font-bold">Meal type</label>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-start w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                    {dietTypesArray?.map((d_array, index) => (
                      <li
                        className="flex items-center border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600"
                        key={index}
                      >
                        <div className="flex items-center p-3 w-full">
                          <input
                            id={d_array?.optionValue + "checkbox-list"}
                            type="checkbox"
                            value={formData[d_array] === false ? true : false}
                            name={d_array?.optionValue}
                            onChange={handleChange}
                            className="w-6 h-6 accent-[#ffa050] checked:accent-[#ff9950] border-1 border-[#ffa050] rounded-lg transition-all duration-300  hover:ring-[#ffa050] focus:outline-none ]"
                          />
                          <label
                            htmlFor={d_array?.optionValue + "checkbox-list"}
                            className="ml-2 text-sm font-medium text-gray-900 dark:text-[#333] cursor-pointer "
                          >
                            {d_array?.option}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 justify-between mt-10 gap-2">
                <div className="mb-4">
                  <label className="font-bold">Meal Frequency</label>
                  {/* <input
                    type="text"
                    className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                    placeholder="eg: Diet bowl"
                    defaultValue={"breakfast"}
                    name="dietFrequency"
                    disabled
                    readOnly
                  /> */}

                  <select
                    className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                    name="dietFrequency"
                    onChange={handleChange}
                  >
                    <option value={"breakfast"}>Breakfast</option>
                    <option value={"morning_snacks"}>Morning snacks</option>
                    <option value={"lunch"}>Lunch</option>
                    <option value={"evening_snacks"}>Evening snacks</option>
                    <option value={"dinner"}>Dinner</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label className="font-bold">Meal Frequency</label>

                  <select
                    className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                    name="dietTypes"
                    onChange={handleChange}
                  >
                    <option value={"veg"}>Veg</option>
                    <option value={"non_veg"}>Non Veg</option>
                    <option value={"vegan"}>Vegan</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="font-bold">Total calorie</label>
                  <input
                    type="number"
                    className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                    placeholder="eg: 20"
                    name="dietCal"
                    defaultValue={formData.dietCal}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="font-bold">Meal name</label>
                <input
                  type="text"
                  className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                  placeholder="eg: Diet bowl"
                  name="dietTitle"
                  defaultValue={formData.dietTitle}
                  onChange={handleChange}
                  minLength={10}
                  maxLength={50}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="font-bold">Description</label>
                <textarea
                  type="text"
                  className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                  placeholder="eg: Tell us more about this meal"
                  name="dietDescription"
                  rows={5}
                  defaultValue={formData.dietDescription}
                  onChange={handleChange}
                  required
                  maxLength={190}
                />
              </div>
              {formData.dietIngredients.map((ingredient, index) => (
                <div key={index} className="mb-4">
                  <label className="font-bold">Ingredient #{index + 1}</label>
                  <div className="grid xl:grid-cols-7 lg:grid-cols-7 md:grid-cols-7 sm:grid-cols-4 grid-cols-2 justify-between gap-3">
                    <input
                      type="text"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Title"
                      name="title"
                      value={ingredient.title}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    <input
                      type="number"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Quantity"
                      name="quantity"
                      value={ingredient.quantity}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    <input
                      type="number"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Calorie"
                      name="ingredientsCal"
                      value={ingredient.ingredientsCal}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    <input
                      type="number"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Fat"
                      name="nutrientsFat"
                      value={ingredient.nutrientsFat}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    <input
                      type="number"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Carbs"
                      name="nutrientsCarbs"
                      value={ingredient.nutrientsCarbs}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    <input
                      type="number"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Protein"
                      name="nutrientsProtein"
                      value={ingredient.nutrientsProtein}
                      onChange={(e) => handleIngredientChange(index, e)}
                      required
                    />
                    {/* <input
                      type="text"
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg"
                      placeholder="Unit"
                      name="unit"
                      value={ingredient.unit}
                      onChange={(e) => handleIngredientChange(index, e)}
                    /> */}
                    <select
                      className="w-full border-2 border-[#ddd] p-2 rounded-lg text-capitalize"
                      name="unit"
                      onChange={(e) => handleIngredientChange(index, e)}
                    >
                      <option hidden value={ingredient?.unit || "g"} selected>
                        {ingredient?.unit || "g"}
                      </option>
                      <option>ml</option>
                      <option>kg</option>
                      <option>g</option>
                      <option>spoon</option>
                    </select>
                  </div>
                </div>
              ))}

              <div className="flex gap-2 mt-4 mb-4 ">
                <button
                  type="button"
                  onClick={addIngredient}
                  className="text-center lg:w-1/3 md:w-1/2 w-full cursor-pointer bg-[green] py-2.5 rounded-xl text-white"
                >
                  <i className="fa fa-plus-circle"></i> Add More Ingredient
                </button>
                <button
                  type="button"
                  onClick={removeIngredient}
                  className="text-center lg:w-1/3 md:w-1/2 w-full cursor-pointer bg-[red] py-2.5 rounded-xl text-white"
                >
                  <i className="fa fa-minus-circle"></i> Remove Last Ingredient
                </button>
              </div>
              <div className="mt-10 mb-4">
                {saveBtnStatus && (
                  <input
                    type="submit"
                    name="add_custom_meal"
                    value="Save this meal"
                    className="text-center lg:w-1/3 md:w-1/2 w-full mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl"
                  />
                )}
              </div>
            </form>
          </div>
          <div className="flex sm:flex-row flex-col sm:justify-start justify-center">
            <div>
              <div className="cardbox sm:w-full w-full bg-cover bg-center px-0">
                <div className="mode1">
                  <img
                    className="watchImg"
                    alt="watchImg"
                    src={
                      "https://imgftbv1.fastbetter.com/1723027279051lzjpydaj51.png"
                    }
                  />
                  <div>
                    <p className="cardboxtitle text-base">
                      Healthy life belongs to everyone
                    </p>
                    <p className="text-xs">
                      Get receipe tailored to your needs and preferences.
                    </p>
                    <button
                      className="mt-2 light-orgn-btn rounded-lg text-[11px] text-capitalize"
                      onClick={() => {
                        history("/mealdiet/custom/list/" + category);
                      }}
                    >
                      View all custom {category}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainBg>
    </>
  );
};
export default CreateCustomMeal;
